import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { RawHTML } from '@wordpress/element';
export default function save() {
  return createElement(RawHTML, null, '<!--nextpage-->');
}
//# sourceMappingURL=save.js.map